import React from "react"

import AggregateShellComponent from "../../../../../gd-modules/common/aggregate/aggregate-shell"
import {
    AggregateFunctionLabel,
    AggregateFunctionType
} from "../../../../../data-structures/aggregators/types"
import TasksView_Column from "../../../../../model2/column/column"
import FieldFormula from "../../formula";

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldFormula_AggregateCell"
const debug = false

export default function FieldFormula_AggregateCell(props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value)
    const value = isValid ? props.value : null

    const valueLabel = props.column.field?.getDisplayValue(typeof value === 'number' ? value : parseFloat(value))

    let noDataLabel;
    switch (props.column.aggregateFunction) {
        case AggregateFunctionType.SUM:
            noDataLabel = ''
            break

        default:
            noDataLabel = props.column.aggregateFunction ?
                AggregateFunctionLabel[props.column.aggregateFunction]
                : ''
            break
    }

    let currencyMark
    const field: FieldFormula = props.column.field as FieldFormula
    switch (field.formatType) {
        case 'currency':
            currencyMark = gd.const.currency[field.symbolId!]?.symbol || null
            break
    }

    const options = props.column.field?.getAggregateOptions()

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {value}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <>
                    <div className="aggregate-label">
                        {AggregateFunctionLabel[props.column.aggregateFunction!]}:
                    </div>
                    <div className="aggregate-value aggregate-number">
                        {currencyMark} {valueLabel}
                    </div>
                </>}

            {!isValid &&
                <div className="aggregate-value aggregate-no-data">
                    {noDataLabel}
                </div>}
        </AggregateShellComponent>
    )
}
